import { FC, lazy, ReactNode, Suspense, useEffect } from 'react'
import { Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom'
import { MasterLayout } from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import { DashboardWrapper } from '../pages/dashboard/DashboardWrapper'
import { getCSSVariableValue } from '../../_metronic/assets/ts/_utils'
import { WithChildren } from '../../_metronic/helpers'
import { useAuth } from '../modules/auth'
import { isValidRole, RoleNameEnum } from '../core/utils/util'

///Acount
const PersonelPageWrappper = lazy(() => import('../pages/personel/Personel.page'))
const ConferenceRoomPage = lazy(() => import('../pages/ConferenceRoom/ConferenceRoom.page'))


////CardTable
const CardTablePage = lazy(() => import('../pages/CardTable/getAll.page'))
const DabirHomePage = lazy(() => import('../pages/CardTable/DabirHome.page'));
const MyWorkPage = lazy(() => import('../pages/CardTable/MyWork.page'));
const WaitingListPage = lazy(() => import('../pages/CardTable/WaitingList.page'));
const ArchiveListPage = lazy(() => import('../pages/CardTable/ArchiveList.page'));
const CardtableDetailPage = lazy(() => import('../pages/CardTable/Detail/Detail.page'));
const AllRequestPage = lazy(() => import('../pages/AllRequest/getAll.page'));
////Supervision
const SupervisionPage = lazy(() => import('../pages/Supervision/getAll.page'))
const SupervisionDabirHomePage = lazy(() => import('../pages/Supervision/DabirHome.page'));
const SupervisionMyWorkPage = lazy(() => import('../pages/Supervision/MyWork.page'));
const SupervisionWaitingListPage = lazy(() => import('../pages/Supervision/WaitingList.page'));
const SupervisionArchiveListPage = lazy(() => import('../pages/Supervision/ArchiveList.page'));
const SupervisionDetailPage = lazy(() => import('../pages/Supervision/Detail/Detail.page'));
////Request
const RequestFormPage = lazy(() => import('../pages/RequestForm/RequestForm'))

////UserDetail
const UserDetailPage = lazy(() => import('../pages/UserDetail/UserDetailPage'))

////Setting
const SettingPage = lazy(() => import('../pages/Setting/Setting.page'))

////ChatPage
const ChatPagePage = lazy(() => import('../pages/Tickets/ChatPage'))

////TicketDetailsPage
const TicketDetailsPage = lazy(() => import('../pages/TicketDetails/TicketDetailsPage'))

////Plans
const PlansPage = lazy(() => import('../pages/Plans/Plans'))

////Letter
const LetterPage = lazy(() => import('../pages/Letter/LetterPage'))


////Users
const UserListPage = lazy(() => import('../pages/users/UserList.page'))

////Wrote
const WroteListPage = lazy(() => import('../pages/Wrote/WrotePage'))

////Faq
const FaqPage = lazy(() => import('../pages/Faq/Faq.page'))

////Survey
const SurveyCategoryPage = lazy(() => import('../pages/survey/SurveyCategory/SurveyCategory.page'))
const SurveryPage = lazy(() => import('../pages/survey/Survery/Survery.pgae'))

//EditProfilePage
const EditProfilePage = lazy(() => import('../pages/EditProfile/EditProfile'))

////SupportVideo
const SupportVideoPage = lazy(() => import('../pages/SupportVideo/SupportVideo.page'))

/// ReportNavigate
const ReportNavigatePage = lazy(() => import('../pages/ReportNavigate/ReportNavigate'))

/// ReportsPage
const ReportsPage = lazy(() => import('../pages/Reports/ReportsPage'))

/// ArchivedDocument
const ArchivedDocumentPage = lazy(() => import('../pages/ArchivedDocument/ArchivedDocument'))

////NotificationPage
const NotificationPage = lazy(() => import('../pages/NotificationPage/NotificationPage'))


////ComplateRequestPage
const ComplateRequestPage = lazy(() => import('../pages/ComplateRequest/ComplateRequest'))

////ContractPreviewPage
const ContractPreviewPage = lazy(() => import('../pages/ContractPreview/ContractPreview'));

////Transaction
const TransactionPage = lazy(() => import('../pages/Transaction/Transaction/Transaction.page'));

////LetterManagement
const LetterManagementPage = lazy(() => import('../pages/LetterManagement/LetterManagement'));

////LetterDetail
const LetterDetailPage = lazy(() => import('../pages/LetterDetail/LetterDetail'));

////CustomText
const CustomTextPage = lazy(() => import('../pages/CustomText/CustomText.page'));

////AccessDeniedPage
const AccessDeniedPagePage = lazy(() => import('../pages/AccessDeniedPage/AccessDeniedPage'));


////Claim
const ClaimPage = lazy(() => import('../pages/Claim/Claim.page'));

const GuardedRoute = ({ children, claim }: { children: ReactNode, claim?: string }) => {
  const { userInfo } = useAuth()
  const userClaims = userInfo?.userClaims?.map((x: any) => x.claimValue) || []
  const hasClaims = userClaims.length > 0

  const can = (p?: string) => {
    if (!hasClaims) return true
    if (!p) return true
    return userClaims.includes(p)
  }

  if (!can(claim)) {
    return <Navigate to='/accessDenied' />
  }

  return <>{children}</>
}


const PrivateRoutes = () => {
  const location = useLocation()
  const navigate = useNavigate()

  const { userInfo } = useAuth()
  const restrictedRoutesForBoard = [
    '/request-form',
    '/letter',
    '/support-video',
    '/archived-document',
    '/plans',
    '/setting-managment',
    '/tickets',
    '/ticket/',
    '/survey-category',
    '/survey-list/',
    '/edit-profile',
    '/personel-list',
    '/complate-request/',
    '/contract-preview/',
    "getall-cardtable-list",
    "cardtable-dabir-list",
    "cardtable-mywork-list",
    "cardtable-waiting-list",
    "cardtable-archive-list",
  ];

  useEffect(() => {
    if (userInfo && isValidRole(userInfo?.userRoles || [], RoleNameEnum.Board)) {
      const pathname = location.pathname;

      const isRestricted = restrictedRoutesForBoard.some((route) =>
        pathname.startsWith(route)
      );

      if (isRestricted) {
        navigate('/dashboard');
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userInfo, location, navigate]);

  return (
    <Routes>
        <Route path='/accessDenied' element={<AccessDeniedPagePage />} />
      <Route element={<MasterLayout />}>
        <Route path='auth/*' element={<Navigate to='/dashboard' />} />
        <Route path='dashboard' element={<DashboardWrapper />} />

        {/* بدون claim */}
        <Route path='/edit-profile' element={<SuspensedView><EditProfilePage /></SuspensedView>} />
        <Route path='/notifications' element={<SuspensedView><NotificationPage /></SuspensedView>} />
        <Route path='/conference-room' element={<SuspensedView><ConferenceRoomPage /></SuspensedView>} />
        <Route path='/user-detail/*' element={<SuspensedView><UserDetailPage /></SuspensedView>} />
        <Route path='/complate-request/:requestId' element={<SuspensedView><ComplateRequestPage /></SuspensedView>} />
        <Route path='/add-claim/:personelId' element={<SuspensedView><ClaimPage /></SuspensedView>} />
        <Route path='/contract-preview/:requestId' element={<SuspensedView><ContractPreviewPage /></SuspensedView>} />
        <Route path='/detailletter/:letterId' element={<SuspensedView><LetterDetailPage /></SuspensedView>} />

        {/* با claim */}
        <Route path='/request-form' element={<SuspensedView><GuardedRoute claim='RequestForm'><RequestFormPage /></GuardedRoute></SuspensedView>} />
        <Route path='/all-transaction' element={<SuspensedView><GuardedRoute claim='Finance.AllTransactions'><TransactionPage /></GuardedRoute></SuspensedView>} />
        <Route path='/personel-list' element={<SuspensedView><GuardedRoute claim='Personnel'><PersonelPageWrappper /></GuardedRoute></SuspensedView>} />
        <Route path='/support-video' element={<SuspensedView><GuardedRoute claim='TrainingVideos'><SupportVideoPage /></GuardedRoute></SuspensedView>} />
        <Route path='/archived-document' element={<SuspensedView><GuardedRoute claim='LetterArchive'><ArchivedDocumentPage /></GuardedRoute></SuspensedView>} />
        <Route path='/getall-cardtable-list/:statusId' element={<SuspensedView><GuardedRoute claim='Cartable'><CardTablePage /></GuardedRoute></SuspensedView>} />
        <Route path='/cardtable-detail/:id' element={<SuspensedView><GuardedRoute claim='Cartable'><CardtableDetailPage /></GuardedRoute></SuspensedView>} />
        <Route path='/cardtable-dabir-list' element={<SuspensedView><GuardedRoute claim='Cartable'><DabirHomePage /></GuardedRoute></SuspensedView>} />
        <Route path='/cardtable-mywork-list' element={<SuspensedView><GuardedRoute claim='Cartable'><MyWorkPage /></GuardedRoute></SuspensedView>} />
        <Route path='/cardtable-waiting-list' element={<SuspensedView><GuardedRoute claim='Cartable.WaitingList'><WaitingListPage /></GuardedRoute></SuspensedView>} />
        <Route path='/cardtable-archive-list' element={<SuspensedView><GuardedRoute claim='Cartable.Archive'><ArchiveListPage /></GuardedRoute></SuspensedView>} />
        <Route path='/getall-supervision-list/:statusId' element={<SuspensedView><GuardedRoute claim='Supervision'><SupervisionPage /></GuardedRoute></SuspensedView>} />
        <Route path='/supervision-dabir-list' element={<SuspensedView><GuardedRoute claim='Supervision'><SupervisionDabirHomePage /></GuardedRoute></SuspensedView>} />
        <Route path='/supervision-detail/:id' element={<SuspensedView><GuardedRoute claim='Supervision'><SupervisionDetailPage /></GuardedRoute></SuspensedView>} />
        <Route path='/supervision-mywork-list' element={<SuspensedView><GuardedRoute claim='Supervision'><SupervisionMyWorkPage /></GuardedRoute></SuspensedView>} />
        <Route path='/supervision-waiting-list' element={<SuspensedView><GuardedRoute claim='Supervision'><SupervisionWaitingListPage /></GuardedRoute></SuspensedView>} />
        <Route path='/supervision-archive-list' element={<SuspensedView><GuardedRoute claim='Supervision'><SupervisionArchiveListPage /></GuardedRoute></SuspensedView>} />
        <Route path='/reports-navigate' element={<SuspensedView><GuardedRoute claim='Reports'><ReportNavigatePage /></GuardedRoute></SuspensedView>} />
        <Route path='/reports-navigate/:type' element={<SuspensedView><GuardedRoute claim='Reports'><ReportsPage /></GuardedRoute></SuspensedView>} />
        <Route path='/setting-managment' element={<SuspensedView><GuardedRoute claim='Settings'><SettingPage /></GuardedRoute></SuspensedView>} />
        <Route path='/tickets' element={<SuspensedView><GuardedRoute claim='Support'><ChatPagePage /></GuardedRoute></SuspensedView>} />
        <Route path='/ticket/:id' element={<SuspensedView><GuardedRoute claim='Support'><TicketDetailsPage /></GuardedRoute></SuspensedView>} />
        <Route path='/custom-text' element={<SuspensedView><GuardedRoute claim='SuggestedTexts'><CustomTextPage /></GuardedRoute></SuspensedView>} />
        <Route path='/plans' element={<SuspensedView><GuardedRoute claim='SubscriptionManagement'><PlansPage /></GuardedRoute></SuspensedView>} />
        <Route path='/letter' element={<SuspensedView><GuardedRoute claim='Application.AllLetters'><LetterPage /></GuardedRoute></SuspensedView>} />
        <Route path='/faq' element={<SuspensedView><GuardedRoute claim='FAQ'><FaqPage /></GuardedRoute></SuspensedView>} />
        <Route path='/survey-category' element={<SuspensedView><GuardedRoute claim='QAndA'><SurveyCategoryPage /></GuardedRoute></SuspensedView>} />
        <Route path='/survey-list/:categoryId' element={<SuspensedView><GuardedRoute claim='QAndA'><SurveryPage /></GuardedRoute></SuspensedView>} />
        <Route path='/user-list' element={<SuspensedView><GuardedRoute claim='Users'><UserListPage /></GuardedRoute></SuspensedView>} />
        <Route path='/wrote' element={<SuspensedView><GuardedRoute claim='Automation.Copies'><WroteListPage /></GuardedRoute></SuspensedView>} />
        <Route path='/management-letter' element={<SuspensedView><GuardedRoute claim='Automation.View'><LetterManagementPage /></GuardedRoute></SuspensedView>} />
        <Route path='/all-request/:statusId' element={<SuspensedView><GuardedRoute claim='Application.AllRequests'><AllRequestPage /></GuardedRoute></SuspensedView>} />

        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({ children }) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export { PrivateRoutes }
